import styled from "styled-components";

import { UserTabsMenuItemStyledProps as Props } from "./UserTabsMenuItem.types";

const UserTabsMenuItemStyled = styled.div<Props>`
  & path {
    fill: ${props =>
      props.active ? "var(--palette-gray-s0-l51)" : "var(--palette-white)"};
  }

  && .TabsMenuItem__title {
    color: ${props =>
      props.active ? "var(--palette-gray-s0-l51)" : "var(--palette-white)"};
  }

  .UserTabsMenuItem {
  }
`;

export default UserTabsMenuItemStyled;
